
import messageAlert from "@/components/drawer/components/messageAlert.vue"
import editAddress from "@/components/drawer/editAddress.vue"
import { getCurrentAddress, clearBeforeSet } from "@/utils/utils"
import { deleteAddress } from "@/api/address"

export default {
  components: {
    editAddress,
    messageAlert
  },
  data() {
    return {
      addressList: [],
      action: "",
      visible: false,
      addresses: {},
      showEmty: false,
      labelOPtions: {
        Home: this.$t("address.home"),
        Work: this.$t("address.office")
      },
      messageAlertVisibale: false,
      messageAlert: {
        title: this.$t("address.removeTips"),
        cancel: this.$t("address.cancel"),
        ok: this.$t("address.remove")
      }
    }
  },
  mounted() {
    this.$store.dispatch("getLoginInfo").then(res => {
      if (res?.address?.length > 0) {
        this.addressList = res.address
        this.showEmty = false
      } else {
        this.showEmty = true
      }
    })
  },
  methods: {
    initAddress(accountInfo) {
      this.addressList = accountInfo?.address || []
      this.showEmty = this.addressList.length <= 0
    },
    handlePlusAddress() {
      this.action = "add"
      this.visible = true
    },
    handleEdit(item) {
      this.action = "edit"
      this.visible = true
      this.addresses = item
    },
    handleRemove(item) {
      this.action = "remove"
      this.addresses = item
      this.messageAlert = {
        title: this.$t("address.removeTips"),
        cancel: this.$t("address.cancel"),
        ok: this.$t("address.yes")
      }
      this.messageAlertVisibale = true
    },
    handleCancel() {
      this.messageAlertVisibale = false
      if (this.action === "remove") {
        this.action = ""
      }
    },
    async handleOk() {
      this.messageAlertVisibale = false
      if (["add", "edit"].includes(this.action)) {
        this.visible = false
        this.action = ""
        return
      }
      this.action = ""
      const currentAddress = getCurrentAddress()
      if (currentAddress?.id == this.addresses.id) {
        this.$message({
          message: this.$t("address.removeError"),
          type: "warning"
        })
        return
      }
      try {
        const { code, data } = await deleteAddress({ param: JSON.stringify({ id: this.addresses.id }) })
        if (code !== "0000") {
          this.$message({
            message: data?.msg || "delete fail",
            type: "warning"
          })
          return
        }
        this.$message({
          message: this.$t("address.addressRemoved"),
          type: "success"
        })
        const accountInfo = await this.$store.dispatch("getLoginInfo")
        if (accountInfo?.address?.length <= 0) {
          clearBeforeSet()
        }
        this.initAddress(accountInfo)
      } catch (error) {
        console.log("🚀 ~ .then ~ error:", error)
      }
    },
    handleClose() {
      this.messageAlert = {
        title: this.$t("address.editTips"),
        cancel: this.$t("address.cancel"),
        ok: this.$t("address.notarize")
      }
      this.messageAlertVisibale = true
    },
    handleSave(accountInfo) {
      this.visible = false
      this.action = ""
      this.initAddress(accountInfo)
    }
  }
}
